export default "__VITE_ASSET__DsrQHO2u__"